import { Link } from 'react-router-dom';
import MetaHead from '../components/MetaHead';
import { DanmarkTilskudCard } from '../components/SygeforsikringDanmark';

export default function PriserPage() {
  const tilskudsoversigt = [
    {
      kategori: 'SUNDHEDSFORSIKRINGER / ofte med læge henvisning',
      status: 'JA',
      note: null
    },
    {
      kategori: 'TRYG',
      status: 'JA',
      note: null
    },
    {
      kategori: 'PRIMACARE',
      status: 'JA',
      note: null
    },
    {
      kategori: 'PRESCRIBA',
      status: 'JA',
      note: null
    },
    {
      kategori: 'UNGE MELLEM 18 og 25 år MED LÆGEHENVISNING TIL GRATIS TERAPI (I ANGST/DEPRESSIONS KATEGORIEN)',
      status: 'JA',
      note: null
    },
    {
      kategori: 'LÆGEHENVISNING I YDERNUMMERORDNINGEN ALENE',
      status: 'NEJ',
      note: 'jeg er trådt ud af ordningen, da den genererer optil ½ års ventetid.'
    },
    {
      kategori: 'ARBEJDSPLADS BETALT',
      status: 'JA',
      note: null
    },
    {
      kategori: 'FAGFORENINGS BETALT',
      status: 'JA',
      note: null
    },
    {
      kategori: 'PENSIONSSELSKAB BETALT',
      status: 'JA',
      note: null
    },
    {
      kategori: 'EGENBETALINGSMULIGHED',
      status: 'JA',
      note: null
    },
    {
      kategori: '"danmark" Sygeforsikrings tilskud',
      status: 'JA',
      note: null
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12">
      <MetaHead 
        title="Priser - Din Privat Psykolog"
        description="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogTitle="Priser og tilskud - Din Privat Psykolog"
        ogDescription="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogImage="https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/image_005daf1a.png"
      />

      {/* Header */}
      <div className="border-b border-[#E0D7C6] pb-8 space-y-3">
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#5f7365]">
          Priser og tilskud
        </h1>
        <p className="text-base sm:text-lg text-[#3B4D42] max-w-3xl leading-relaxed">
          Oversigt over honorarer for samtaleterapi samt muligheder for tilskud fra forsikring eller Sygeforsikringen "danmark".
        </p>
      </div>

      {/* Price Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        
        {/* Card 1: Individuel terapi */}
        <div className="bg-white p-6 sm:p-8 flex flex-col justify-between space-y-6">
          <div className="space-y-4">
            <div>
              <h2 className="font-serif text-2xl font-bold text-[#5f7365]">
                Individuel terapi
              </h2>
              <p className="text-xs text-[#52685B]">
                Samtaleterapi, online terapi eller walk and talk
              </p>
            </div>

            <div className="flex items-baseline gap-2 pt-2 border-b border-[#EDE6D8] pb-4">
              <span className="font-serif text-3xl sm:text-4xl font-bold text-[#5f7365]">
                Kr 1.200
              </span>
              <span className="text-sm font-semibold text-[#52685B]">
                / 45 min
              </span>
            </div>

            <div className="space-y-2 text-xs sm:text-sm text-[#384A3F]">
              <p className="font-semibold text-[#5f7365]">
                Eventuelt med tilskud fra enten:
              </p>
              <ul className="space-y-1.5 list-disc pl-5">
                <li>Sygeforsikringen "danmark"</li>
                <li>Sundhedsforsikring</li>
                <li>Ulykkesforsikring</li>
                <li>Pensionsselskab</li>
                <li>Fagforening</li>
              </ul>
            </div>
          </div>

          <div className="pt-4 border-t border-[#EDE6D8]">
            <Link
              to="/kontakt"
              className="w-full py-3 px-4 bg-[#5f7365] hover:bg-[#4e6053] text-white font-semibold rounded-none text-sm text-center block transition-all duration-200 hover:-translate-y-1 shadow-2xs"
            >
              Bestil individuel tid
            </Link>
          </div>
        </div>

        {/* Card 2: Par / Familieterapi */}
        <div className="bg-white p-6 sm:p-8 flex flex-col justify-between space-y-6">
          <div className="space-y-4">
            <div>
              <h2 className="font-serif text-2xl font-bold text-[#5f7365]">
                Par / familie terapi
              </h2>
              <p className="text-xs text-[#52685B]">
                Målrettet to eller flere deltagere
              </p>
            </div>

            <div className="flex items-baseline gap-2 pt-2 border-b border-[#EDE6D8] pb-4">
              <span className="font-serif text-3xl sm:text-4xl font-bold text-[#5f7365]">
                Kr 1.800
              </span>
              <span className="text-sm font-semibold text-[#52685B]">
                / 90 min
              </span>
            </div>

            <p className="text-xs sm:text-sm text-[#384A3F] leading-relaxed">
              Udvidet tid til parforholdsproblemer, skilsmisse, sammenbragte familier eller familiekonflikter.
            </p>
          </div>

          <div className="pt-4 border-t border-[#EDE6D8]">
            <Link
              to="/kontakt"
              className="w-full py-3 px-4 bg-[#F8F5EE] hover:bg-white border border-[#5f7365] text-[#5f7365] font-semibold rounded-none text-sm text-center block transition-all duration-200 hover:-translate-y-1 shadow-2xs"
            >
              Bestil par-/familietid
            </Link>
          </div>
        </div>

      </div>

      {/* Insurance & Lægehenvisning Rules */}
      <div className="space-y-6 text-sm text-[#5f7365] leading-relaxed pt-6 border-t border-[#EDE6D8]">
        <div className="space-y-2">
          <h2 className="font-serif text-xl sm:text-2xl font-bold text-[#5f7365]">
            DU KAN MED FORDEL UNDERSØGE DINE EVENTUELLE TILSKUDSMULIGHEDER PÅ FORHÅND
          </h2>
          <p className="text-xs text-[#52685B] uppercase tracking-wider font-semibold">
            Lægehenvisning, forsikringer og Sygeforsikringen "danmark"
          </p>
        </div>

        {/* Overskuelig tabel over tilskuds- og betalingsmuligheder */}
        <div className="overflow-hidden bg-white border border-[#EDE6D8] shadow-xs">
          <div className="bg-[#FAF8F5] px-4 sm:px-6 py-3.5 border-b border-[#EDE6D8] flex items-center justify-between">
            <h3 className="font-serif text-base sm:text-lg font-bold text-[#5f7365]">
              Oversigt over tilskuds- og finansieringsmuligheder
            </h3>
            <span className="text-[11px] text-[#52685B] font-medium hidden sm:inline">
              Oversigt over dækning
            </span>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse text-xs sm:text-sm">
              <thead>
                <tr className="border-b border-[#EDE6D8] bg-[#F7F4EE]/60 text-[#3B4D42]">
                  <th scope="col" className="py-3 px-4 sm:px-6 font-semibold">
                    Tilskudstype / Forsikring / Betalingsform
                  </th>
                  <th scope="col" className="py-3 px-4 sm:px-6 font-semibold w-40 text-right sm:text-left">
                    Mulighed / Status
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#EDE6D8]/80 text-[#384A3F]">
                {tilskudsoversigt.map((item, idx) => (
                  <tr 
                    key={idx}
                    className={`hover:bg-[#FAF8F5]/80 transition-colors ${idx % 2 === 0 ? 'bg-white' : 'bg-[#FAF8F5]/30'}`}
                  >
                    <td className="py-3.5 px-4 sm:px-6 font-medium text-[#2C3B32]">
                      <div className="space-y-1">
                        <span className="leading-snug block">
                          {item.kategori}
                        </span>
                        {item.note && (
                          <span className="text-xs text-[#8A4A3A] font-normal block italic">
                            – {item.note}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="py-3.5 px-4 sm:px-6 align-top text-right sm:text-left whitespace-nowrap">
                      {item.status === 'JA' ? (
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-bold bg-[#EAF3EC] text-[#2F613B] border border-[#CDE3D2]">
                          <i className="fa-solid fa-check text-[11px]" aria-hidden="true" />
                          <span>JA</span>
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-bold bg-[#FBF0EE] text-[#9E392B] border border-[#F2D2CC]">
                          <i className="fa-solid fa-xmark text-[11px]" aria-hidden="true" />
                          <span>NEJ</span>
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Sygeforsikringen "danmark" Feature Card */}
        <DanmarkTilskudCard className="my-6 shadow-xs" />

        <div className="space-y-4 text-xs sm:text-sm text-[#384A3F] border-t border-[#E5DFD1] pt-4">
          <p>
            Dén type lægehenvisning, der laves af egen læge via sygesikringsordningen, (Ydernummer) udløser ikke i sig selv tilskud i min klinik. Jeg har nemlig valgt at træde ud af ordningen, fordi den genererer lang ventetid.
          </p>

          <p>
            MEN sammen med en evt. forsikring udløser en lægehenvisning alligevel helt eller delvis betaling. Efterhånden er der mange forsikringsselskaber, der giver helt eller delvist tilskud til psykologhjælp ved selvvalgt autoriseret psykolog. Husk at tjekke vilkår og muligheder og medbring deres bekræftelse til mig, hvis du ønsker at undgå at lægge pengene ud, fordi jeg oftest kan afregne direkte med dem.
          </p>

          <div className="p-4 bg-white border border-[#EDE6D8] text-[#5f7365] font-medium flex items-start gap-3">
            <i className="fa-regular fa-info-circle text-[#5f7365] text-lg mt-0.5 shrink-0" />
            <p>
              Medlemmer af <strong>Sygeforsikringen "danmark"</strong> (Gruppe 1, 2 og 5) får altid følgende beløb retur: <strong className="text-rose-900 font-bold">-300 kr. pr. session</strong> (Bemærk der er et årligt loft for max tilskud jf. "danmarks" gældende takster).
            </p>
          </div>
        </div>
      </div>

      {/* Payment and Cancellation Rules */}
      <div className="space-y-4 text-sm text-[#5f7365] pt-6 border-t border-[#EDE6D8]">
        <h2 className="font-serif text-xl font-bold text-[#5f7365]">
          Betalingsmuligheder og afbudsregler
        </h2>

        <div className="space-y-3 text-xs sm:text-sm text-[#384A3F] leading-relaxed">
          <p>
            Der betales på dagen umiddelbart efter samtalen, hvis du er selvbetalende. Der kan betales med Mobilepay, kontant eller via bankoverførsel.
          </p>

          <div className="py-3 border-y border-[#EDE6D8] text-[#2C211A] space-y-1">
            <p className="font-bold text-rose-900 flex items-center gap-2">
              <i className="fa-regular fa-clock" />
              Afbud senest 24 timer før
            </p>
            <p className="text-xs text-[#523B30]">
              Afbud gives via telefonbesked, SMS på <strong className="whitespace-nowrap">29 92 18 79</strong> eller e-mail <strong className="whitespace-nowrap">kontakt@dinprivatpsykolog.dk</strong>, senest 24 timer for samtalestart. Ved senere eller manglende afbud opkræves det fulde beløb for den bookede terapi. Bemærk at ingen forsikringer dækker for udeblivelser, så dem hæfter man selv for.
            </p>
          </div>

          <div className="pt-2">
            <Link
              to="/velkomstbrev"
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#5f7365] hover:underline"
            >
              <i className="fa-regular fa-arrow-right" />
              Se mere praktisk information i velkomstbrevet
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
